import React, { useMemo } from "react";

import {
  FaChalkboardTeacher,
  FaUserClock,
  FaUsers,
  FaUserShield,
} from "react-icons/fa";

import {
  SectionHeader,
  StatCard,
} from "../ui/DashboardUI";

import { nf } from "../utils/dashboard.utils";

export default function UsersStatsSection({
  stats,
  loading,
}) {
  const cards = useMemo(() => {
    const total = Number(stats?.total || 0);

    const percentage = (value) =>
      total > 0
        ? Math.round(
            (Number(value || 0) / total) * 100,
          )
        : 0;

    return [
      {
        label: "Total utilisateurs",
        value: nf.format(stats?.total || 0),
        icon: FaUsers,
        tone: "indigo",
        sub: "Tous comptes confondus",
      },
      {
        label: "Mode démo",
        value: nf.format(stats?.modeDemo || 0),
        icon: FaUserClock,
        tone: "slate",
        sub: `${percentage(stats?.modeDemo)} %`,
      },
      {
        label: "Présence Free",
        value: nf.format(stats?.presenceFree || 0),
        icon: FaUserShield,
        tone: "blue",
        sub: `${percentage(stats?.presenceFree)} %`,
      },
      {
        label: "Présence",
        value: nf.format(stats?.presence || 0),
        icon: FaUserShield,
        tone: "blue",
        sub: `${percentage(stats?.presence)} %`,
      },
      {
        label: "Présence Pro",
        value: nf.format(stats?.presencePro || 0),
        icon: FaUserShield,
        tone: "emerald",
        sub: `${percentage(stats?.presencePro)} %`,
      },
      {
        label: "Présence Ultim",
        value: nf.format(stats?.presenceUltim || 0),
        icon: FaUserShield,
        tone: "amber",
        sub: `${percentage(stats?.presenceUltim)} %`,
      },
      {
        label: "Enseignants",
        value: nf.format(stats?.enseignants || 0),
        icon: FaChalkboardTeacher,
        tone: "rose",
        sub: `${percentage(stats?.enseignants)} %`,
      },
    ];
  }, [stats]);

  return (
    <section className="mb-6">
      <SectionHeader
        title="Utilisateurs"
        subtitle="Répartition des comptes et des formules."
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((card) => (
          <StatCard
            key={card.label}
            {...card}
            loading={loading}
          />
        ))}
      </div>
    </section>
  );
}